<template>
  <v-btn
    v-if="appUserInstanceCanCreateNewBooking"
    large
    color="primary"
    outlined
    @click="$router.push({ name: 'createBookingOverview' })"
  >
    <i class="fal fa-plus mr-2"></i>
    {{ $t('shopBackendBookingComplete.addBooking') }}
  </v-btn>
</template>

<script>
import definitions from '../../../definitions'

export default {
  name: 'EnterBookingBtn',

  asyncComputed: {
    // permission short cut
    async appUserInstanceCanCreateNewBooking() {
      return await this.$store.getters
        .getAppUserInstance()
        ?.doIHavePermissionInTheCurrentDestinationForKey(
          definitions.permissions.shopApi.BOOKING_ADMIN_CHECKOUT
        )
    },
  },
}
</script>
